import { IListItem } from "../../classes/list-item";
import { IAppAction } from "../../classes/action";
import { ActionType } from "../actions/actiontype";
import { Action } from "redux";

export interface IResponsiveState {
    isMobile: boolean;
}

export const defaultResponsiveState: IResponsiveState = {
    isMobile: false
};

export function responsiveReducer(state = defaultResponsiveState, action: IAppAction): IResponsiveState {
    switch (action.type) {
        case ActionType.TRANSITION_DESKTOP: {
            return { ...state, isMobile: false };
        }

        case ActionType.TRANSITION_MOBILE: {
            return { ...state, isMobile: true };
        }

        default: {
            return state;
        }
    }
}